import { BASE_URL } from "../../config";
import { REQ_PROFILE, SET_PROFILE, SET_ERROR_STATE, REQ_PROFILE_DONE } from "../../utils/constants/actionTypes";
import { GProf } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";

export default (ClientID, cb) => async (dispatch) => {
	dispatch({ type: REQ_PROFILE });
	try {
		let res = await fetch(`${BASE_URL}${GProf}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
			},
		});

		let hasil = await res.json();

		if (res.status === 200) {
			const { borrower } = hasil.result;
			let isCompleteProfile = false;
			let isVerifiedProfile = false;
			if ((borrower.status === "VER" || borrower.status === "SBM") && (borrower.customerInfo.corporate.status === "VER" || borrower.customerInfo.corporate.status === "SBM")) {
				isCompleteProfile = true;
			}

			if (borrower.status === "VER" && borrower.customerInfo.corporate.status === "VER") {
				isVerifiedProfile = true;
			}

			dispatch({ type: SET_PROFILE, payload: { ...hasil.result.borrower, isCompleteProfile, isVerifiedProfile } });
			cb && cb(true);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_PROFILE_DONE });
			bugsnagClient.notify(new Error(`Profil.js/ (line 23) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: REQ_PROFILE_DONE });
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		bugsnagClient.notify(new Error(`Profil.js/ (line 28) ===> catch - ${err.message}`));
	}
};
